import { useEffect, useState } from 'react';
import Loader from './helpers/Loader';
import axios from 'axios';
import './index.css';

const CREATE_INBOUND_URL = 'https://ger.wa.48.defaultbot.com/v2-api/inbounds/create';
const UPDATE_INBOUND_URL = 'https://ger.wa.48.defaultbot.com/v2-api/inbounds/update';
const DELETE_INBOUND_URL = 'https://ger.wa.48.defaultbot.com/v2-api/inbounds/delete';
const UPDATE_INBOUND_ADVANCED_URL = 'https://ger.wa.48.defaultbot.com/v2-api/inbounds/advanced/update';
const ENABLE_REPLACER_URL = 'https://ger.wa.48.defaultbot.com/v2-api/inbounds/advanced/enableReplacer';
const DISABLE_REPLACER_URL = 'https://ger.wa.48.defaultbot.com/v2-api/inbounds/advanced/disableReplacer';

const GET_SERVER_URL = 'https://ger.wa.48.defaultbot.com/v2-api/vless/getServer';
const GET_INBOUNDS_URL = 'https://ger.wa.48.defaultbot.com/v2-api/vless/getInbounds';
const SAVE_SERVER_URL = 'https://ger.wa.48.defaultbot.com/v2-api/vless/saveServer';
const DELETE_KEY_URL = 'https://ger.wa.48.defaultbot.com/v2-api/vless/deleteKey';
const DISABLE_AUTO_ENABLE_URL = 'https://ger.wa.48.defaultbot.com/v2-api/vless/disableAutoEnable';
const ENABLE_AUTO_ENABLE_URL = 'https://ger.wa.48.defaultbot.com/v2-api/vless/enableAutoEnable';
const DISABLE_KEY_URL = 'https://ger.wa.48.defaultbot.com/v2-api/vless/disableKey';
const ENABLE_KEY_URL = 'https://ger.wa.48.defaultbot.com/v2-api/vless/enableKey';
const MIGRATE_SERVER_THIN_URL = 'https://ger.wa.48.defaultbot.com/v4/migrateServerThin/vless';
const MIGRATE_TO_DOUBLE_INBOUND_URL = 'https://ger.wa.48.defaultbot.com/v2-api/vless/migrateToDoubleInbound';


const NewInboundOverlay = ({ vless_server_id, close, reload }) => {

	const [inboundId, setInboundId] = useState("");
	const [inboundFlow, setInboundFlow] = useState("");
	const [port, setPort] = useState("");

	const [isCreating, setCreating] = useState(false);

	const handleCreateInbound = async () => {
		if (port.trim() === '') {
			return
		}

		if (inboundId.trim() === '') {
			return;
		}

		if (isCreating) {
			return;
		}
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		setCreating(true);
		const data = { inbound_id: inboundId, vless_server_id: vless_server_id, flow: inboundFlow, port: port };

		const creationRequest = await axios.post(CREATE_INBOUND_URL, data, { headers: { Authorization: `Bearer ${token}` } });
		if (!creationRequest.data.ok) {
			alert("Something went wrong");
		} else {
			reload();
			close();
		}

		setCreating(false);
	}

	return <div className='overlay' style={{ zIndex: '99999' }}>
		<div className='overlay-content'>
			<input className='t-input' value={inboundId} placeholder='Inbound ID' onChange={e => setInboundId(e.target.value)}></input>
			<select
				className='t-input'
				placeholder='Flow'
				value={inboundFlow}
				onChange={(e) => setInboundFlow(e.target.value)}
			>
				<option value={"xtls-rprx-vision"}>xtls-rprx-vision</option>
				<option value={""}>Empty</option>
			</select>
			<input className='t-input' value={port} placeholder='Port' onChange={e => setPort(e.target.value)}></input>
			<button onClick={() => handleCreateInbound()} className='t-button'>{isCreating ? <Loader /> : <>Создать</>}</button>

			<button onClick={() => close()} className='t-button'>Закрыть</button>
		</div>
	</div>
}

const InboundComponent = ({ inboundData, vless_server_id, reload }) => {

	const [isEnabled, setIsEnabled] = useState(inboundData.is_enabled);
	const [inboundId, setInboundId] = useState(inboundData.vless_inbound_id);
	const [inboundFlow, setInboundFlow] = useState(inboundData.flow);
	const [port, setPort] = useState(inboundData.port);
	const [isSaving, setSaving] = useState(false);
	const [isToggling, setToggling] = useState(false);

	// ALTER TABLE simple_inbounds ADD COLUMN replaced_port TEXT DEFAULT NULL;
	// ALTER TABLE simple_inbounds ADD COLUMN replaced_security TEXT DEFAULT NULL;
	// ALTER TABLE simple_inbounds ADD COLUMN replaced_alpn TEXT DEFAULT NULL;
	// ALTER TABLE simple_inbounds ADD COLUMN replaced_sni TEXT DEFAULT NULL;
	// ALTER TABLE simple_inbounds ADD COLUMN replaced_fingerprint TEXT DEFAULT NULL;

	const [replacingHost, setReplacingHost] = useState(inboundData.replaced_host ?? 'vpndomain.org');
	const [replacingPort, setReplacingPort] = useState(inboundData.replaced_port ?? '8443');
	const [replacingSecurity, setReplacingSecurity] = useState(inboundData.replaced_security ?? 'tls');
	const [replacingAlpn, setReplacingAlpn] = useState(inboundData.replaced_alpn ?? 'http/1.1')
	const [replacingSni, setReplacingSni] = useState(inboundData.replaced_sni ?? 'vpndomain.org');
	const [replacingFingerprint, setReplacingFingerprint] = useState(inboundData.replaced_fingerprint ?? 'firefox');

	const [isDeletionConfirmationOpen, setDeletetionConfigurationOpen] = useState(false);
	const [isAdvancedSettingsOpen, setAdvancedSettingsOpen] = useState(false);
	const [isSavingAdvancedSettings, setSavingAdvancedSettings] = useState(false);
	const [isTogglingAdvancedSettings, setTogglingAdvancedSettings] = useState(false);
	const [isReplacerEnabled, setReplacerEnabled] = useState(inboundData.is_replacing_enabled);

	const handleSaveAdvancedSettings = async () => {
		if (isSavingAdvancedSettings) { return };
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		setSavingAdvancedSettings(true);

		// { id, vless_server_id, port, security, alpn, sni, fingerprint }
		const data = {
			id: inboundData.id,
			vless_server_id: vless_server_id,
			host: replacingHost,
			port: replacingPort,
			security: replacingSecurity,
			alpn: replacingAlpn,
			sni: replacingSni,
			fingerprint: replacingFingerprint
		};
		console.log({ data });
		const request = await axios.post(UPDATE_INBOUND_ADVANCED_URL, data, { headers: { Authorization: `Bearer ${token}` } });
		const response = request.data;
		if (!response.ok) {
			alert("Something went wrong");
		}
		setSavingAdvancedSettings(false);
	}

	const handleSaveInbound = async () => {
		if (isSaving) { return };
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		setSaving(true);

		const data = { id: inboundData.id, inbound_id: inboundId, vless_server_id: vless_server_id, flow: inboundFlow, port: port };
		console.log({ data });
		const request = await axios.post(UPDATE_INBOUND_URL, data, { headers: { Authorization: `Bearer ${token}` } });
		const response = request.data;
		if (!response.ok) {
			alert("Something went wrong");
			setInboundId(response.inbound.vless_inbound_id);
			setInboundFlow(response.inbound.flow);
			setPort(response.inbound.port);
		}
		setSaving(false);
	}


	const enableInboundReplacer = async () => {
		if (isTogglingAdvancedSettings) { return };
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		console.log("EnableInboundReplacer")
		setTogglingAdvancedSettings(true);
		const data = { id: inboundData.id, vless_server_id: vless_server_id, };
		const request = await axios.post(ENABLE_REPLACER_URL, data, { headers: { Authorization: `Bearer ${token}` } });
		const response = request.data;

		if (response.ok) {
			setReplacerEnabled(true);
		}

		setTogglingAdvancedSettings(false)
	}


	const disableInboundReplacer = async () => {
		if (isTogglingAdvancedSettings) { return };
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		console.log("DisableInboundReplacer")
		setTogglingAdvancedSettings(true);
		const data = { id: inboundData.id, vless_server_id: vless_server_id, };
		const request = await axios.post(DISABLE_REPLACER_URL, data, { headers: { Authorization: `Bearer ${token}` } });
		const response = request.data;

		if (response.ok) {
			setReplacerEnabled(false);
		}

		setTogglingAdvancedSettings(false)
	}

	// const enableInbound = async () => {
	// 	if (isToggling) { return };
	// 	setToggling(true);
	// 	const data = { id: inboundData.id, vless_server_id: vless_server_id, };
	// 	const request = await axios.post("https://ger.wa.48.defaultbot.com/v2-api/inbounds/enable", data);
	// 	const response = request.data;

	// 	if (response.ok) {
	// 		setIsEnabled(true);
	// 	}


	// 	setToggling(false)
	// }


	// const disableInbound = async () => {
	// 	if (isToggling) { return };
	// 	setToggling(true);
	// 	const data = { id: inboundData.id, vless_server_id: vless_server_id, };
	// 	const request = await axios.post("https://ger.wa.48.defaultbot.com/v2-api/inbounds/disable", data);
	// 	const response = request.data;

	// 	if (response.ok) {
	// 		setIsEnabled(false);
	// 	}

	// 	setToggling(false)
	// }

	const deleteInbound = async () => {
		if (isToggling) { return };
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		setToggling(true);
		const data = { id: inboundData.id, vless_server_id: vless_server_id, };
		const request = await axios.post(DELETE_INBOUND_URL, data, { headers: { Authorization: `Bearer ${token}` } });
		const response = request.data;

		if (response.ok) {
			setIsEnabled(false);
		}

		setDeletetionConfigurationOpen(false)
		setToggling(false);
		reload();
	}

	return <>
		{isDeletionConfirmationOpen && <div className='overlay'>
			<div className='overlay-content'>
				<div>Do you want to delete ${inboundId} inbound?</div>
				<button className='t-button' onClick={() => deleteInbound()}>Удалить</button>
				<button className='t-button' onClick={() => setDeletetionConfigurationOpen(false)}>Отмена</button>
			</div>
		</div>}

		{isAdvancedSettingsOpen && <div className='overlay'>
			<div className='overlay-content'>
				<div>{inboundId} - Advanced Settings</div>
				<input className='t-input' value={replacingHost} onChange={e => setReplacingHost(e.target.value)} type='text' placeholder='Replacing Host' />
				<input className='t-input' value={replacingPort} onChange={e => setReplacingPort(e.target.value)} type='text' placeholder='Replacing Port' />
				<input className='t-input' value={replacingSecurity} onChange={e => setReplacingSecurity(e.target.value)} type='text' placeholder='Replacing Security' />
				<input className='t-input' value={replacingAlpn} onChange={e => setReplacingAlpn(e.target.value)} type='text' placeholder='Replacing ALPN' />
				<input className='t-input' value={replacingSni} onChange={e => setReplacingSni(e.target.value)} type='text' placeholder='Replacing SNI' />
				<input className='t-input' value={replacingFingerprint} onChange={e => setReplacingFingerprint(e.target.value)} type='text' placeholder='Replacing FingerPrint' />
				<button className='t-button' onClick={() => handleSaveAdvancedSettings()}>{isSavingAdvancedSettings ? <Loader /> : <>Сохранить</>}</button>
				<button className='t-button' onClick={isReplacerEnabled ? () => disableInboundReplacer() : () => enableInboundReplacer()}> {isTogglingAdvancedSettings ? <Loader /> : isReplacerEnabled ? <>Выключить подмену</> : <>Включить подмену</>} </button>
				<button className='t-button' onClick={() => setAdvancedSettingsOpen(false)}>Закрыть</button>
			</div>
		</div>}

		<div className='inbound-meta-container'>
			<div className='inbound-container'>
				<div><span>Status</span></div>
				<div><span>ID</span></div>
				<div><span>Flow</span></div>
				<div><span>Config Port</span></div>
			</div>

			<div className='inbound-container'>
				<div className='dot-container'>
					<div className={(isReplacerEnabled && isEnabled) ? 'status-round purple' : isEnabled ? 'status-round green' : 'status-round red'}></div>
				</div>
				<input className='t-input' value={inboundId} onChange={e => setInboundId(e.target.value)}></input>
				<select
					className='t-input'
					placeholder='Flow'
					value={inboundFlow}
					onChange={(e) => setInboundFlow(e.target.value)}
				>
					<option value={"xtls-rprx-vision"}>xtls-rprx-vision</option>
					<option value={""}>Empty</option>
				</select>
				<input className='t-input' value={port} onChange={e => setPort(e.target.value)}></input>
				<button className='t-button' onClick={() => {
					setAdvancedSettingsOpen(true);

				}}>⚙️</button>
				<button className='t-button' onClick={() => handleSaveInbound()}>{isSaving ? <Loader /> : <>Сохранить</>}</button>
				{/* <button className='t-button' onClick={isEnabled ? () => disableInbound() : () => enableInbound()}>{isToggling ? <Loader /> : isEnabled ? "Выключить" : "Включить"}</button> */}
				<button className='t-button' onClick={() => setDeletetionConfigurationOpen(true)}>Удалить</button>
			</div></div ></>
}

export default function ServerOverlayVless({ id, close, getList }) {
	const [isLoading, setLoading] = useState(true);
	const [comment, setComment] = useState('');

	const [serverData, setServerData] = useState({});
	const [userLimit, setUserLimit] = useState(null);
	const [sni, setSni] = useState("");
	const [isSaving, setSaving] = useState(false);
	const [wantDeleteServer, setWantDeleteServer] = useState(false);
	const [isDeletingServer, setDeletingServer] = useState(false);
	const [serverStatus, setServerStatus] = useState(false);
	const [serverAutoEnable, setServerAutoEnable] = useState(false);
	const [isTogglingServer, setTogglingServer] = useState(false);
	const [isMigratingToSecondInbound, setMigratingToSecondInbound] = useState(false);
	const [isAutoEnablingUpdating, setAutoEnablingUpdating] = useState(false);
	const [xuiVersion, setXuiVersion] = useState('');

	const [inboundsList, setInboundsList] = useState([]);

	const [flow, setFlow] = useState('');
	const [flowTwo, setFlowTwo] = useState('');

	const [isURLEnabled, setURLEnabled] = useState(false);
	const [urlAddress, setURLAddress] = useState("");

	const [inboundId, setInboundId] = useState('1');
	const [inboundIdTwo, setInboundIdTwo] = useState('-1');
	const [isSecondInboundEnabled, setSecondInboundEnabled] = useState(false);

	const [serverUrl, setServerUrl] = useState("");
	const [serverKeyUrl, setServerKeyUrl] = useState("");

	const [isNewInboundOpen, setNewInboundOpen] = useState(false);

	const [isThinnlyMigrating, setThinnlyMigrating] = useState(false);

	const migrateUsersFromServerThinnly = async () => {
		if (isThinnlyMigrating) {
			return;
		}
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		setThinnlyMigrating(true);

		const request = await axios.post(MIGRATE_SERVER_THIN_URL, { vless_server_id: id }, { headers: { Authorization: `Bearer ${token}` } });
		const response = request.data.ok;
		if (response === true) {
			alert("Success")
		} else {
			alert("Failure at thin migration");
		}

		setThinnlyMigrating(false);
		// /v4/migrateServerThin/vless
	}


	const fetchInbounds = async () => {
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		const data = { id: id };
		const request = await axios.post(GET_INBOUNDS_URL, data, { headers: { Authorization: `Bearer ${token}` } });
		setInboundsList(request.data.inbounds);
	}

	const loadServerData = async () => {
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		const data = {
			id: id,
		};
		console.log(id);
		const request = await axios.post(GET_SERVER_URL, data, { headers: { Authorization: `Bearer ${token}` } });

		setComment(request.data.server.comment);
		setServerStatus(request.data.server.enabled);
		setServerAutoEnable(request.data.server.is_auto_enabled);
		setUserLimit(request.data.server.user_limit !== 0 ? request.data.server.user_limit : '');
		setServerData(request.data.server);
		setURLEnabled(request.data.server.is_url_enabled);
		setURLAddress(request.data.server.url_address);
		setXuiVersion(request.data.server.xui_version);
		setSecondInboundEnabled(request.data.server.is_second_inbound_enabled);
		setFlow(request.data.server.flow);
		setSni(request.data.server.sni);
		setServerUrl(request.data.server.url);
		setServerKeyUrl(request.data.server.key_url);
		// setInboundsList(request.data.inbounds);
		setLoading(false);
	};

	useEffect(() => {
		loadServerData();
		fetchInbounds();
	}, []);

	const handleClose = (event) => {
		const { id } = event.target;
		if (id === 'overlay') {
			close();
		}
	};

	const toggleAutoEnable = async () => {
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		setAutoEnablingUpdating(true);
		const url = serverAutoEnable ? DISABLE_AUTO_ENABLE_URL : ENABLE_AUTO_ENABLE_URL;
		const request = await axios.post(url, { id: id }, { headers: { Authorization: `Bearer ${token}` } });

		if (request.data.ok) {
			setServerAutoEnable(!serverAutoEnable);
			setAutoEnablingUpdating(false);
			getList();
		}
	}

	const toggleKey = async () => {
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		setTogglingServer(true);
		const url = serverStatus ? DISABLE_KEY_URL : ENABLE_KEY_URL;
		const request = await axios.post(url, { id: id }, { headers: { Authorization: `Bearer ${token}` } });

		if (request.data.ok) {
			setServerStatus(!serverStatus);
			setTogglingServer(false);
			getList();
		}
	};

	const deleteKey = async (event) => {
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		setDeletingServer(true);
		const data = {
			id: id,
		};
		const request = await axios.post(DELETE_KEY_URL, data, { headers: { Authorization: `Bearer ${token}` } });
		console.log({ delete: request.data });
		if (request.data.ok) {
			close();
			getList();
		} else {
			alert(JSON.stringify(request.data));
		}
	};

	const saveServer = async () => {
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		setSaving(true);
		const data = {
			id: id,
			comment: comment,
			user_limit: userLimit !== null && userLimit !== NaN && userLimit !== '' ? parseInt(userLimit) : 0,
			url_enabled: isURLEnabled,
			url_address: urlAddress,
			xui_version: xuiVersion,
			flow: flow,
			sni: sni,
			ip: serverUrl,
			key_ip: serverKeyUrl
		};
		console.log(data);
		const request = await axios.post(SAVE_SERVER_URL, data, { headers: { Authorization: `Bearer ${token}` } });
		if (request.data.ok) {
			setSaving(false);
			getList();
		}
	};


	const enableSecondInboundWithMigration = async () => {
		if (isMigratingToSecondInbound) {
			return;
		}
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		setMigratingToSecondInbound(true);

		const migrationRequestData = {
			id: serverData.id,
			inbound_id_two: inboundIdTwo,
			flow_two: flowTwo
		}

		const migrationRequest = await axios.post(MIGRATE_TO_DOUBLE_INBOUND_URL, migrationRequestData, { headers: { Authorization: `Bearer ${token}` } });
		console.log({ migrationRequest: migrationRequest.data });
		if (migrationRequest.data.ok) {
			alert("Success")
			loadServerData();
		} else {
			alert("Failure")
		}
		setMigratingToSecondInbound(false);

	}

	return (
		<div className='overlay overlay-right' id='overlay' onClick={handleClose}>
			<div className='overlay-content  overlay-content-right'>
				{isLoading ? (
					<div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '300px' }}>
						<Loader />
					</div>
				) : (
					<>
						{isNewInboundOpen && <NewInboundOverlay vless_server_id={serverData.id} close={() => setNewInboundOpen(false)} reload={() => fetchInbounds()} />}
						<div className='server-label'>
							<span>id: </span>
							{serverData.id}
						</div>
						<div className='server-label'>
							<span>url </span>
							<input type='text' className='t-input' value={serverUrl} placeholder='server URL' onChange={(e) => setServerUrl(e.target.value)} />
						</div>

						<div className='server-label'>
							<span>key_url</span>
							<input type='text' className='t-input' value={serverKeyUrl} placeholder='server key URL' onChange={(e) => setServerKeyUrl(e.target.value)} />
						</div>
						<div className='server-label'>
							<span>login/password: </span>
							{serverData.login} / {serverData.password}
						</div>
						<div className='server-label'>
							{comment.length !== 0 && <span>Name</span>}
							<input type='text' className='t-input' value={comment} placeholder='Comment' onChange={(e) => setComment(e.target.value)} />
						</div>
						<div className='server-label'><span>Inbounds Table</span>
							<div onClick={() => setNewInboundOpen(true)}>Добавить новый</div>
						</div>
						<div className='inbounds-container'>
							{inboundsList.map((inboundData) => {
								return <InboundComponent key={inboundData.id} reload={() => fetchInbounds()} vless_server_id={serverData.id} inboundData={inboundData} />
							})}
						</div>

						{/* <div className='server-label'>
							<span>Second Inbound</span>
							{isSecondInboundEnabled ? <div className='server-label'> <>Второй Inbound включен</></div> : <>
								<div className='t-data-double'>
									<input
										className='t-input'
										placeholder='InboundID Second'
										type='text'
										value={inboundIdTwo}
										onChange={(e) => setInboundIdTwo(e.target.value.trim())}
									></input>
									<select
										className='t-input'
										placeholder='Flow'
										value={flowTwo}
										onChange={(e) => setFlowTwo(e.target.value)}
									>
										<option value={"xtls-rprx-vision"}>xtls-rprx-vision</option>
										<option value={""}>Empty</option>
									</select>
								</div>
								<button className='t-button' disabled={isMigratingToSecondInbound} onClick={enableSecondInboundWithMigration}>
									{isMigratingToSecondInbound ? 'Перенастраиваем и мигрируем...' : 'Включить Second Inbound'}
								</button>
							</>}
						</div> */}

						<div className='server-label'>
							<span>User limit</span>
							<input
								type='number'
								className='t-input'
								value={userLimit}
								placeholder='User Limit'
								onChange={(e) => setUserLimit(e.target.value)}
							/>
						</div>
						<div className='server-label'>
							<span>SNI</span>
							<input
								type='text'
								className='t-input'
								value={sni}
								placeholder='SNI'
								onChange={(e) => setSni(e.target.value)}
							/>
						</div>


						<div className='server-label'>
							<span>Server Version</span>
							<select
								className='t-input'
								placeholder='API Version'
								value={xuiVersion}
								disabled={true}
								onChange={(e) => setXuiVersion(e.target.value)}
							>
								<option value={"2.6.2"}>2.6.2 (stable)</option>
								<option value={"3.0.1"}>3.0.1</option>
							</select>
						</div>
						{/* 

						<div className='server-label'>
							<span>Flow (Default)</span>

							<select
								className='t-input'
								placeholder='Flow'
								value={flow}
								onChange={(e) => setFlow(e.target.value)}
							>
								<option value={"xtls-rprx-vision"}>xtls-rprx-vision</option>
								<option value={""}>Empty</option>
							</select>
						</div> */}

						<button className='t-button' onClick={toggleKey}>
							{isTogglingServer ? <Loader /> : serverStatus ? 'Выключить сервер' : 'Включить сервер'}
						</button>


						<button className='t-button' onClick={toggleAutoEnable}>
							{isAutoEnablingUpdating ? <Loader /> : serverAutoEnable ? 'Выключить авто-включение' : 'Включить авто-включение'}
						</button>
						<div className='server-label'>
							<span>URL</span>
							<div>
								<input
									type='checkbox'
									id='trial-select'
									checked={isURLEnabled}
									value={isURLEnabled}
									onChange={() => setURLEnabled(!isURLEnabled)}
									name='trial-select'
									label='URL Enabled'
								></input>
								<label className='t-checkbox-label'>URL Enabled</label>
							</div>
							{isURLEnabled && (
								<>
									<input
										type='text'
										className='t-input'
										value={urlAddress}
										placeholder='https://address.domain'
										onChange={(e) => setURLAddress(e.target.value)}
									/>
								</>
							)}
						</div>

						<button className='t-button t-primary' onClick={saveServer}>
							{isSaving ? <Loader /> : 'Сохранить'}
						</button>


						<button className='t-button ' onClick={() => close()}>
							Закрыть
						</button>


						<button className='t-button ' onClick={() => migrateUsersFromServerThinnly()}>
							{isThinnlyMigrating ? <>Размазываем</> : <> Миграция тонким слоем</>}
						</button>

						<div>
							<input
								type='checkbox'
								id='trial-select'
								checked={wantDeleteServer}
								onChange={() => setWantDeleteServer(!wantDeleteServer)}
								name='trial-select'
								label='Хочу удалить сервер'
							></input>
							<label className='t-checkbox-label'>Хочу удалить сервер</label>
						</div>

						{wantDeleteServer && (
							<button onClick={deleteKey} className='t-button t-danger'>
								{isDeletingServer ? <Loader /> : 'Удалить сервер'}
							</button>
						)}
					</>
				)}
			</div>
		</div>
	);
}
